(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ProductTypeDeleteDialogController', ProductTypeDeleteDialogController);

    ProductTypeDeleteDialogController.$inject = ['$uibModalInstance', 'entity', 'ProductType', 'MessageService', '$timeout', '$rootScope'];

    function ProductTypeDeleteDialogController ($uibModalInstance, entity, ProductType, MessageService, $timeout, $rootScope) {
        var vm = this;

        vm.productType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.error = false;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProductType.delete({id: id}, function() {
                MessageService.success("productType.message.deleted");
                $uibModalInstance.close(true);
                $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
            }, function () {
                vm.error = true;
            });
        }
    }
})();
